import { render } from "./DetailFellowship.vue?vue&type=template&id=f683b660&scoped=true"
import script from "./DetailFellowship.vue?vue&type=script&lang=js"
export * from "./DetailFellowship.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f683b660"]])

export default __exports__